import { createSelector } from 'reselect'

const getInteractiveVideo = state => state.interactiveVideo

export default createSelector(
	[ getInteractiveVideo ],
	interactiveVideo => (
		{
			availableLanguages: interactiveVideo.settings.captions,
			selectedLanguage: interactiveVideo.settings.selectedLanguage,
		}
	)
)
